/**
 * @docs: docs/core/architecture/SCOUT_GATEWAY_REMOTE.md
 *
 * My Devices › Shared with you: SGs whose owners let me in, as crew (looks
 * only) or fleet operator, each with Open SG. Hidden when there are none.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { OpenSgButton } from './OpenSgButton';

export function SharedSgList() {
  const { data } = useQuery({ queryKey: ['gateways', 'shared'], queryFn: () => api.getSharedGateways(), retry: false });
  const devices = data?.devices ?? [];
  if (devices.length === 0) return null;
  return (
    <section className="space-y-3" data-testid="shared-sgs">
      <h2 className="text-lg font-semibold text-white">Shared with you</h2>
      <div className="grid gap-4 md:grid-cols-2">
        {devices.map((d) => (
          <div key={d.device_id} className="bg-slate-800/50 rounded-xl border border-slate-700 p-4 space-y-3">
            <div>
              <p className="text-white font-medium">{d.name || d.serial_number}</p>
              <p className="text-sm text-slate-400">
                Scout Gateway · {d.role === 'crew' ? 'crew, looks only' : 'fleet operator'}
                {d.until ? ` · until ${new Date(d.until).toLocaleDateString('en-NZ')}` : ''}
              </p>
            </div>
            <OpenSgButton deviceId={d.device_id} />
          </div>
        ))}
      </div>
    </section>
  );
}
